export default {
  "1": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Crypto ID :"])},
  "2": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Langue"])},
  "3": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Bonjour"])},
  "4": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Bon après-midi"])},
  "5": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Bonne soirée"])},
  "6": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Bonne nuit"])},
  "7": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Déconnexion"])}
}